export default __webpack_public_path__ + "static/media/portfolio-midios-2.321e6646.jpg";